__turbopack_context__.v({
  "ellipsis": "overflow-tooltip-module-scss-module__EJ6eNa__ellipsis",
  "multiline": "overflow-tooltip-module-scss-module__EJ6eNa__multiline",
});
